import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Radio, Select } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { INode } from '@mrblenny/react-flow-chart';
import { LinkType } from '../enums';

interface IRemoveBooleanConditionConfirmationModal {
    node: INode,
}

interface IState {
    type: string,
}

export class RemoveBooleanConditionConfirmationModal extends React.Component<IRemoveBooleanConditionConfirmationModal, IState> {
    public state: IState = {
        type: 'all',
    };

    public render() {
        return (
            <div>
                <p>
                    You are removing a condition in the
                    middle of an existing series of actions.
                    To continue you can:
                </p>
                <div>
                    <Form.Item>
                        <Radio.Group
                            size="small"
                            onChange={(ev: RadioChangeEvent) => {
                                const type = ev.target.value === 'all' ?
                                    'all' : LinkType.POSITIVE;
                                this.setState({ type });
                            }}
                            value={this.state.type === 'all' ? 'all' : 'branch'}
                        >
                            <Radio.Button value="all">Remove All</Radio.Button>
                            <Radio.Button value="branch">Preserve Specific Branch</Radio.Button>
                        </Radio.Group>
                    </Form.Item>

                    {this.state.type !== 'all' && (
                        <Form.Item>
                            <Select
                                size="small"
                                value={this.state.type}
                                onChange={(type: string) => this.setState({ type })}
                            >
                                <Select.Option value={LinkType.POSITIVE}>Positive Branch</Select.Option>
                                <Select.Option value={LinkType.NEGATIVE}>Negative Branch</Select.Option>
                            </Select>
                        </Form.Item>
                    )}
                </div>
            </div>
        );
    }
}
